import { GURU_LITE_OFFER_PARTNER_UIDS } from '../constants/guru-partner';
import { usePartnerSummary } from '../queries/usePartnerSummary';

export const useIsGuruLiteOfferPartner = () => {
  const { data: partnerSummary, isLoading, error } = usePartnerSummary();

  const partnerUID = partnerSummary?.getPartnerUID();

  return {
    isGuruLiteOfferPartner: partnerUID !== undefined && GURU_LITE_OFFER_PARTNER_UIDS.includes(partnerUID),
    isLoading,
    error,
  };
};

export type UseIsGuruLiteOfferPartner = ReturnType<typeof useIsGuruLiteOfferPartner>;
